import './AadhaarManual.css'; 
import propic from '../Pics/propic.webp' 
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
let AadhaarManual=(props)=>{
    let navigate = useNavigate();
    let [inputs, setunputs]=useState({});
    let [image, setimage]=useState(null);
    let [qr, setqr] = useState(null);
       
     let imagechangehandle =(e)=>{
        if(e.target.files && e.target.files[0]){
            setimage(URL.createObjectURL(e.target.files[0]))
        }
     }
    let inputchangehandler=(e)=>{
    let name = e.target.name;
    let value = e.target.value;
    setunputs(values =>({...values, [name]: value}));
    
}
    let AadharDataSaveFunction=()=>{
         




        let AadharData={
            AadharNoIssued: inputs.aadharissudate,
            photo: image,
            engname: inputs.nameeng,
            hinname: inputs.namehin,
            dob: inputs.dob,
            gender: inputs.gender,
            aadharnum: inputs.aadharnum,
            vid: inputs.vid,
            addreng: inputs.addrineng,
            addrhin: inputs.addrinhin,
            detailsason: inputs.detason,
            qr: qr
        }
       if(AadharData.engname==undefined){
        props.Successandrerrorfun("","Enter Name");
        return;
       }else if(AadharData.hinname==undefined){
        props.Successandrerrorfun("","Enter Name in Hindi")
        return;
       }else if(AadharData.dob==undefined){
        props.Successandrerrorfun("","Enter Dob");
            return;
       }else if(AadharData.gender==undefined){
        props.Successandrerrorfun("","Select Gender")
            return;
       }else if(AadharData.aadharnum==undefined){
        props.Successandrerrorfun("","Enter Aadhar Number")
            return;
       }else if(AadharData.addreng==undefined){
        props.Successandrerrorfun("","Address Required")
            return;
       }else if(AadharData.addrhin==undefined){
        props.Successandrerrorfun("","Addrss Required in hindi");
            return;
       }else if(AadharData.photo==null){
        props.Successandrerrorfun("","Select photo")
            return;
       }
        props.Gotdata(AadharData)
        navigate('/printManual');  
        
         
    }
    return(
        <div className='aadharmanualmaincont'>
            <h1 className='aadharmanualheadhin'>Print Aadhaar Manually </h1>
            <div className='cmaindiv'>
                <div className='topaadhaarheadingpic'> 
                    <div className='middlediv'>
                        <div className='divleft'>
                            {
                                image != null ? <img src={image}/> : <img src={propic}/>
                            }
                            <div>
                                <label className='aadharphotouploadlabel' htmlFor='inpfilepropic'>Upload photo as on aadhaar</label>
                                 <input onChange={imagechangehandle} name='aadharphoto' style={{display:"none"}} id='inpfilepropic' type='file'/>
                            </div>
                        </div>
                        <div className='divright'>
                            <div>
                                <label htmlFor='inpdate'>Aadhaar no. issued:</label>
                                <input name='aadharissudate' onChange={inputchangehandler} placeholder='Enter Date' id='inpdate'  type='text'/>
                            </div>
                            <div>
                                <label htmlFor='inpnameeng'>Name in English</label>
                                <input name='nameeng' placeholder='EnterName(English)' onChange={inputchangehandler} id='inpnameeng' type='text'/>

                            </div>
                            <div>
                                  <label htmlFor='inpnamehin'>Name in Hindi</label>
                                <input name='namehin' placeholder='EnterName(Hindi)' onChange={inputchangehandler} id='inpnamehin' type='text'/>
                            </div>
                            <div>
                                  <label htmlFor='dob'>Date of birth</label>
                                <input name='dob' placeholder='DOB' onChange={inputchangehandler} id='dob'  type='text'/>
                            </div>
                            <div>
                                 <label htmlFor='inpgender'>Select Gender</label>
                                 <span>
                                    <input  value="पुरूष/Male" onChange={inputchangehandler} id='inpgender' name='gender' type='radio'/>Male 
                                    <input  value="महिला/Female"  onChange={inputchangehandler}  name='gender' id='inpgender' type='radio'/>Female 
                                </span>
                            </div>
                            <div>
                                 <label htmlFor='inpaadharnum'>Aadhaar Number</label>
                                 <input placeholder='AadhaarNumber' name='aadharnum' onChange={inputchangehandler} id='inpaadharnum'  type='text'/>
                            </div>
                            <div>
                                 <label htmlFor='VID'>Enter Aadhaar VID</label>
                                 <input placeholder='AadhaarVID' name='vid' onChange={inputchangehandler} id='VID'  type='text'/>
                            </div>
                            <div>
                                 <label htmlFor='detailsason'>Details as on:</label>
                                 <input name='detason' onChange={inputchangehandler} id='detailsason'  type='text'/>
                            </div>
                        </div>
                    </div>
                    <div className='bottomdiv'>
                        <div className='bottomleftdiv'>
                            <label htmlFor='addrinhindi'>Address in Hindi(Same As aadhaar)</label>
                            <input name='addrinhin' onChange={inputchangehandler} id='addrinhindi' type='text' placeholder='Address In Hindi'/>
                            <label htmlFor='addrinenglish'>Address in English(aadhaar address)</label>
                            <input name='addrineng' onChange={inputchangehandler} id='addrinenglish' type='text' placeholder='Address In English'/>
                        </div>
                        <div className='bottomrightdiv'>
                            <label className='hidelable' htmlFor='qr'>Upload Aadhar Qr</label>
                            <input name='addrqr' onChange={(e)=>{
                                if(e.target.files.length != 0){
                                    document.querySelector(".hidelable").style.display="none"
                                    e.target.style.display="block"
                                    setqr(URL.createObjectURL(e.target.files[0]))
                                }
                                
                            }} className='qrfile' style={{display:"none"}} id='qr' type='file'/>

                        </div>
                        
                    </div>
                    <div style={{width:"100%", textAlign:"center", margin:"10px"}}>
                        <button onClick={AadharDataSaveFunction}><a className='Savelink'  style={{borderRadius:"5px"}}  >Submit</a></button>
                        
                    </div>
                    
                   
                   
                </div>
                
            </div>
            
        </div>
    )
}

export default AadhaarManual;